import { create } from "zustand";

export const enum DeflowSessionStates {
  NotAuthenticated = "NOT_AUTHENTICATED",
  Authenticating = "AUTHENTICATING",
  Authenticated = "AUTHENTICATED",
  AuthenticationError = "AUTHENTICATION_ERROR",
}

export type DeflowSession = {
  sessionState: DeflowSessionStates;
  lastSignIn?: number;
  tokens?: {
    accessToken: string;
    idToken: string;
    refreshToken: string;
  };
};

type DeflowSessionActions = {
  setAuthenticationError: () => void;
  setNotAuthenticated: () => void;
  setAuthenticated: ({
    lastSignIn,
    tokens,
  }: {
    lastSignIn: DeflowSession["lastSignIn"];
    tokens: DeflowSession["tokens"];
  }) => void;
};

const useDeflowSessionStore = create<DeflowSession & DeflowSessionActions>()(
  (set) => ({
    sessionState: DeflowSessionStates.NotAuthenticated,
    setNotAuthenticated: () =>
      set(() => ({
        sessionState: DeflowSessionStates.NotAuthenticated,
        tokens: undefined,
      })),
    setAuthenticationError: () =>
      set(() => ({
        sessionState: DeflowSessionStates.AuthenticationError,
        tokens: undefined,
      })),
    setAuthenticated: ({ lastSignIn, tokens }) =>
      set(() => ({
        sessionState: DeflowSessionStates.Authenticated,
        lastSignIn,
        tokens,
      })),
  })
);

export default useDeflowSessionStore;
